import React from 'react';
import { Switch, Route } from 'react-router-dom';
import { combineReducers } from 'redux';

import Order from './Order';
import OrderDetails from './Order/Details';

import orderReducer from './Order/store/orderReducer';

export const routes = (basePath) => (
    <Switch>
        {<Route path={basePath} exact component={Order} />}
        {<Route path={'/order/details'} exact component={OrderDetails} />}

    </Switch>
);

export const reducers = combineReducers({
    orders: orderReducer
});
